import { ClusterDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCluster = createAction('[Cluster] Load Cluster');

export const loadClusterSuccess = createAction(
  '[Cluster] Load Cluster Success',
  props<{ cluster: ClusterDto[] }>()
);

export const loadClusterFailure = createAction(
  '[Cluster] Load Cluster Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCluster = createAction(
  '[Cluster] Add Cluster',
  props<{ newCluster: ClusterDto[] }>()
);

export const addClusterSuccess = createAction(
  '[Cluster] Add Cluster Success',
  props<{ newCluster: ClusterDto[] }>()
);

export const addClusterFailure = createAction(
  '[Cluster] Add Cluster Failure',
  props<{ error: any }>()
);

/**
 * Update Cluster Collection Actions
 */
export const updateCluster = createAction(
  '[Cluster] Update Cluster',
  props<{ updateCluster: ClusterDto[] }>()
);

export const updateClusterSuccess = createAction(
  '[Cluster] Update Cluster Success',
  props<{ updateCluster: ClusterDto[] }>()
);

export const updateClusterFailure = createAction(
  '[Cluster] Update Cluster Failure',
  props<{ error: any }>()
);

/**
 * Remove Cluster Collection Actions
 */
export const removeCluster = createAction(
  '[Cluster] Remove Cluster',
  props<{ ids: string[] }>()
);

export const removeClusterSuccess = createAction(
  '[Cluster] Remove Cluster Success',
  props<{ ids: string[] }>()
);

export const removeClusterFailure = createAction(
  '[Cluster] Remove Cluster Failure',
  props<{ error: any }>()
);
